export default "__VITE_ASSET__DprsllY___"